import { forwardRef, useImperativeHandle } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const DownloadBillpdf = forwardRef(({ pdfContentRef, fileName }, ref) => {
  useImperativeHandle(ref, () => ({
    downloadPDF: async () => {
      if (!pdfContentRef.current) return;

      const element = pdfContentRef.current;
      // Give some time for any pending renders
      await new Promise((res) => setTimeout(res, 100));

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const pdfHeight = (canvasHeight * pageWidth) / canvasWidth;

      let heightLeft = pdfHeight;
      let position = 0;

      // first page
      pdf.addImage(imgData, "JPEG", 0, position, pageWidth, pdfHeight);
      heightLeft -= pageHeight;

      // additional pages
      while (heightLeft > 0) {
        position = heightLeft - pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, pageWidth, pdfHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(fileName);
    },
  }));

  return null;
});

export default DownloadBillpdf;
